import React from 'react'

const Error404Page = () => (<h1>GG</h1>)

export default Error404Page